import { useEffect, useState } from "react";

const left = (to) => Math.max(0, new Date(to).getTime() - Date.now());
const UNITS = [["Days", 86400000], ["Hours", 3600000], ["Minutes", 60000], ["Seconds", 1000]];

export const Countdown = ({ to, title, compact = false }) => {
  const [ms, setMs] = useState(() => (to ? left(to) : 0));
  useEffect(() => {
    if (!to) return undefined;
    const t = setInterval(() => setMs(left(to)), 1000);
    return () => clearInterval(t);
  }, [to]);
  if (!to || Number.isNaN(new Date(to).getTime()) || ms <= 0) return null;
  const parts = UNITS.map(([l, u], i) => [l, Math.floor((i ? ms % UNITS[i - 1][1] : ms) / u)]);

  if (compact) return (
    <div data-testid="product-countdown" className="border border-[var(--mm-red)] px-4 py-3 flex items-center justify-between gap-3">
      <span className="eyebrow text-[var(--mm-red)]">{title || "Launching in"}</span>
      <span className="font-serif-mm text-xl tabular-nums">{parts.map(([l, v]) => `${String(v).padStart(2, "0")}${l[0].toLowerCase()}`).join(" ")}</span>
    </div>
  );

  return (
    <section data-testid="launch-countdown-section" className="bg-[var(--mm-red)] text-[var(--mm-cream)] px-6 sm:px-10 lg:px-16 py-12 sm:py-16 grid lg:grid-cols-12 gap-8 items-center">
      <div className="lg:col-span-5">
        <p className="eyebrow opacity-80 mb-3">Launch day</p>
        <h2 className="font-serif-mm text-3xl sm:text-4xl leading-tight">{title || "The first collection arrives in"}</h2>
        <p className="text-sm opacity-80 mt-3">{new Date(to).toLocaleString("en-GB", { weekday: "long", day: "numeric", month: "long", hour: "2-digit", minute: "2-digit" })}</p>
      </div>
      <div className="lg:col-span-7 grid grid-cols-4 gap-3 sm:gap-6">
        {parts.map(([l, v]) => (
          <div key={l} data-testid={`countdown-${l.toLowerCase()}`} className="border-l border-[var(--mm-cream)]/40 pl-3 sm:pl-5">
            <span className="font-serif-mm text-4xl sm:text-6xl lg:text-7xl tabular-nums block leading-none">{String(v).padStart(2, "0")}</span>
            <span className="eyebrow opacity-80 mt-2 block text-[0.6rem]">{l}</span>
          </div>
        ))}
      </div>
    </section>
  );
};
